<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2025-03-04 10:34:38
 * @FilePath: /wemeet-admin-new/src/components/generateWx/generateWx.vue
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
-->
<template>
  <el-drawer ref="drawerRef" v-model="dialogFormVisible" :size="size" :before-close="handleClose" :direction="direction"
    custom-class="demo-drawer">
    <div class="containerForm" v-if="!noQrCodeBox">
      <el-descriptions title="链接详情" direction="vertical" :column="1" :size="desSize" border>
        <el-descriptions-item label="小程序二维码">
          <div style="display: flex">
            <div style="text-align: center">
              <el-image style="width: 300px; height: 300px" :src="qrCodeUrl" :zoom-rate="1.2" :initial-index="4"
                fit="cover" />
              <el-button style="width: 200px; margin-top: 30px; display: block; margin: 30px auto 0 auto" type="primary"
                @click="downLoad(qrCodeUrl)" v-if="!!qrCodeUrl">
                下载
              </el-button>
            </div>
            <div>
              <el-image style="width: 300px; height: 300px" :src="qrUrl" :zoom-rate="1.2" :initial-index="4"
                fit="cover" />
              <el-button style="width: 200px; margin-top: 30px; display: block; margin: 30px auto 0 auto" type="primary"
                @click="downLoad(qrUrl)" v-if="!!qrUrl">
                下载
              </el-button>
            </div>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="小程序短链接">
          <span v-if="!h5Url">{{ shortLinkUrl }}</span>
          <span v-else>{{ h5Url }}</span>
        </el-descriptions-item>
        <el-descriptions-item v-if="qrCodeParams.scenesType != 'EXHIBIT_QRCODE'" label="应用唯一 sence">
          <span>{{ senceKey }}</span>
        </el-descriptions-item>

        <el-descriptions-item v-if="qrCodeParams.scenesType != 'EXHIBIT_QRCODE'" label="应用小程序主页链接">
          <span v-if="qrCodeParams.miniPath">{{ qrCodeParams.miniPath }}</span>
        </el-descriptions-item>

        <el-descriptions-item v-if="qrCodeParams.scenesType != 'EXHIBIT_QRCODE'" label="应用H5报名链接">
          <el-table :data="registerMobileUrl">
            <el-table-column label="身份" prop="name" />
            <el-table-column label="H5报名地址" prop="h5Url" />
          </el-table>
        </el-descriptions-item>

        <!-- <el-descriptions-item label="展会AI助理链接">
          <span v-if="qrCodeParams.miniPath">{{ qrCodeParams.miniPath }}</span>
        </el-descriptions-item> -->
      </el-descriptions>
    </div>
    <div v-else class="containerForm">
      <el-descriptions border :column="1" direction="vertical" :size="desSize" title="链接详情">
        <el-descriptions-item label="网址">
          <a :href="website" target="_blank">{{ website }}</a>
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </el-drawer>
</template>
<script>
import { toRefs, reactive, defineComponent, getCurrentInstance } from 'vue'
import { createQrcode, createShortLink, createPoster } from '@/api/tool'
import { ElLoading } from 'element-plus'
import { baseH5URL } from '@/config'
import { getRegisterConfigList } from '@/api/channel'
import { downloadImageByUrl } from '@/utils/download'

const jumpURL = baseH5URL.replace(/#$/, 'j?c=')

export default defineComponent({
  name: 'generateWx',
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance()
    const state = reactive({
      dialogFormVisible: false,
      direction: 'rtl',
      size: '40%',
      title: '链接地址',
      loading: null,
      row: {},
      qrCodeUrl: '',
      qrUrl: '',
      shortLinkUrl: '',
      desSize: 'large',
      senceKey: '',
      qrCodeParams: {},
      noQrCodeBox: false,
      website: '',
      h5Url: '',
      registerMobileUrl: [],
    })
    // 打开
    const handleOpen = (row = {}, qrCodeParams, noQrcode, h5Url) => {
      state.row = row
      state.qrCodeParams = qrCodeParams
      state.dialogFormVisible = true
      state.loading = ElLoading.service({
        lock: true,
        text: '二维码链接正在生成中，请稍候',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      if (noQrcode) {
        state.noQrCodeBox = true
        state.website = `${baseH5URL}/formData?code=${row.code}`
        state.loading.close()
      } else {
        // 判断是否有定制的 url
        state.h5Url = h5Url
        shortLink()
      }
      generateMobileUrl()
    }
    // 关闭
    const handleClose = () => {
      state.dialogFormVisible = false
      state.qrCodeUrl = ''
      state.qrUrl = ''
      state.senceKey = ''
      state.shortLinkUrl = ''
    }
    const checkAppkey = () => {
      let customInfo = localStorage.getItem('customInfo')
      let tenantKey = ''
      if (customInfo != 'null' && customInfo != 'undefined') {
        customInfo = JSON.parse(customInfo)
        if (!!customInfo.tenantKey) {
          tenantKey = customInfo.tenantKey
        } else {
          tenantKey = ''
        }
      }
      return tenantKey
    }

    const shortLink = async (row) => {
      console.log(checkAppkey())
      const tenantKey = checkAppkey()
      let logo = 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/image/WeMeetMiniLogo.png'
      if (tenantKey == 'MEETSG') {
        logo = 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/image/meetSgQrcodeIcon.png'
      } else if (tenantKey == 'MEHZ') {
        logo = 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/image/mehzQrcodeIcon.png'
      } else if (tenantKey == 'HHXQ') {
        logo = 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/HHXQ/img/hhxq_logo.png'
      } else if (tenantKey == 'GDC') {
        logo =
          'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/globalCommon/gdc/platformLogo.png'
      } else if (tenantKey == 'ZJXZ') {
        logo =
          'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/ZJXZ/assets/icons/logo-text-primary.webp'
      } else {
        logo = 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/image/WeMeetMiniLogo.png'
      }
      createQrcode(state.qrCodeParams)
        .then(async (res) => {
          const linkParams = {
            pageTitle: 'sence跳转',
            params: `{"scene":"${res.data.scenesKey}"}`,
            path: '/pages/index/index',
            type: 'HOMEPAGE',
          }
          state.qrUrl = res.data.value
          const url = `${baseH5URL}/qrCodeByIcon?logo=${logo}&qrCodeUrl=${res.data.value}`
          const data = {
            url,
            width: 750,
            height: 750,
          }

          const { data: value } = await createPoster(data)
          state.qrCodeUrl = value
          state.senceKey = res.data.scenesKey
          createShortLink(linkParams)
            .then((resp) => {
              state.loading.close()
              console.log(resp)
              state.shortLinkUrl = jumpURL + resp.data
            })
            .catch((err) => {
              state.loading.close()
              handleClose()
              proxy.$baseMessage(`生成失败`, 'error', 'vab-hey-message-error')
            })
        })
        .catch((err) => {
          state.loading.close()
          handleClose()
          proxy.$baseMessage(`生成失败`, 'error', 'vab-hey-message-error')
        })
    }

    function downLoad(url) {
      downloadImageByUrl(url, state.row.meetingName)
    }

    const generateMobileUrl = async () => {
      console.log('state', state.row)
      getRegisterConfigList(state.row.code || state.row.meetingCode).then((res) => {
        state.registerMobileUrl = res.data
        state.registerMobileUrl.forEach((v) => {
          v.h5Url = `${baseH5URL}/applyForm?identity=${v.identity}&meetingCode=${v.meetingCode}&meetingType=${v.meetingType
            }&language=${v.identity == 'AUDIENCE_EN' ? 'EN' : 'CN'}`
        })
        console.log(state.registerMobileUrl)
      })
    }
    return {
      ...toRefs(state),
      handleOpen,
      handleClose,
      shortLink,
      downLoad,
    }
  },
})
</script>

<style lang="scss" scoped>
.vab-tree-border {
  height: 200px;
  padding: $base-padding;
  overflow-y: auto;
  border: 1px solid #dcdfe6;
  border-radius: $base-border-radius;
}

.demo-drawer__content {
  height: 85vh;
  overflow: auto;
}

.containerForm {
  height: 85vh;
  overflow-y: auto;
}

.demo-drawer__footer {
  position: fixed;
  right: 20px;
  bottom: 10px;
}
</style>
